// @ts-check

const path = require('path');
const {
  SUPPORTED_LOCALES_OBJ,
  SUPPORTED_LOCALES_ARR,
} = require('@zep-us/i18n');

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: SUPPORTED_LOCALES_OBJ.ko,
    locales: [...SUPPORTED_LOCALES_ARR],
    localeDetection: false,
  },
  debug: false,
  supportedLngs: SUPPORTED_LOCALES_ARR,
  detection: {
    order: [
      'querystring',
      'cookie',
      'localStorage',
      'navigator',
      'htmlTag',
      'path',
      'subdomain',
    ],
  },
  interpolation: {
    escapeValue: false,
  },
  // ⚠️ false 유지 — serverSideTranslations 가 폴백 로케일 리소스도 HTML 에 실어 응답이
  // 커진다. 트레이드오프: 번역이 비면 키 문자열이 보인다. 없는 키는 tsgo 타입체크가,
  // 로케일별 누락은 CI 의 _scripts/i18n/check-locale-parity.mjs 가 막는다.
  fallbackLng: false,
  localePath: path.resolve('./public/locales'),
  // config 는 _app 에서 appWithTranslation 으로 직접 주입하므로 pageProps 에 직렬화해
  // 실을 필요가 없다(실으면 모든 페이지 HTML 이 그만큼 커진다).
  serializeConfig: false,
};
